import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface InfoBubbleContentProps {
  $removePadding?: boolean;
}

/*
 * Style.
 */

const StyledContentDiv = styled.div<InfoBubbleContentProps>`
  position: relative;
  grid-area: content;
  min-width: 0;
  font-size: ${fontSizes.medium};
  line-height: 20px;
  letter-spacing: -0.15px;
  font-weight: ${fontWeights.medium};
  padding: ${(p) => (p.$removePadding ? '0' : '28px 28px 21px 28px')};
`;

/*
 * Component.
 */

export const InfoBubbleContent: FC<PropsWithChildren<InfoBubbleContentProps>> = ({
  children,
  $removePadding,
}) => <StyledContentDiv $removePadding={$removePadding}>{children}</StyledContentDiv>;
